import React from "react";

const NavBar = () => {

    return(
        <nav>
            <p>Movie<span>Dex</span></p>
        </nav>
    );
}

export default NavBar; 